import { render, staticRenderFns } from "./AddAllowanceType.vue?vue&type=template&id=99aaa3a2&"
import script from "./AddAllowanceType.vue?vue&type=script&lang=js&"
export * from "./AddAllowanceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports